<!-- <template v-if="authorizationCheck || showContent">
  <v-layout>
    <slot v-if="authorizationCheck || showContent" v-bind:authorization="authorizationCheck" />
    <slot name="unauthorized" v-else />
  </v-layout>
</template> -->

<template v-if="true">
  <v-layout>
    <slot v-if="true" v-bind:authorization="true" />
    <slot name="unauthorized" v-else />
  </v-layout>
</template>

<script>
  export default {
    name: "authorization",
    props: {
      permissionKey: [String, Array],
      can: String,
      comparisonMethod: {
        type: String,
        default: "or",
      },
    },
    computed: {
      authorizationCheck() {
        let authorizations = this.$store.state.authorization.authorizations;
        authorizations = this.lodash.filter(
          authorizations,
          function(e) {
            if (this.lodash.isArray(this.permissionKey)) {
              return this.permissionKey.includes(e.permissionKey);
            }

            return e.permissionKey === this.permissionKey;
          }.bind(this)
        );

        if (this.comparisonMethod === "or") {
          return this.lodash.reduce(
            authorizations,
            function(result, authorizationCheck) {
              return result || authorizationCheck.can.includes(this.can);
            }.bind(this),
            false
          );
        }

        return true;
      },
      showContent() {
        if (this.can !== "read") {
          return true;
        }

        return false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .layout {
    flex: none;
    display: contents;
  }
</style>
